<template>
  <div id="data-list-pagamentos-inconsistentes">
    <FiltroPagamentoInconsistentes @filtro="loadData($event)" />

    <vx-card>
      <vs-table
        noDataText="Nenhum item encontrado"
        ref="table"
        :data="itens"
        :max-items="itemsPerPage"
      >
        <!-- Header -->
        <div
          slot="header"
          class="flex flex-wrap-reverse items-center flex-grow justify-between"
        >
          <div></div>

          <!-- Seleção das Páginas -->
          <SelectPagination
            :currentPage="currentPage"
            :itemsPerPage="itemsPerPage"
            :length="totalCount"
            @update="itemsPerPage = $event"
          />
        </div>

        <template slot="thead">
          <vs-th>Nosso Número</vs-th>
          <vs-th>Situação Boleto</vs-th>
          <vs-th>Código</vs-th>
          <vs-th>Nome Associado</vs-th>
          <vs-th>Valor Pagamento</vs-th>
          <vs-th>Data Pagamento</vs-th>
          <vs-th class="table-content-center">Verificado</vs-th>
          <vs-th></vs-th>
        </template>

        <!-- Body -->
        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <!-- Nosso Número -->
              <vs-td>{{ tr.nossoNumero }}</vs-td>

              <!-- Situação Boleto -->
              <vs-td>{{ tr.situacao }}</vs-td>

              <!-- Código -->
              <vs-td>
                {{ tr.idAssociado }}
                <router-link
                  class="inline-block"
                  target="_blank"
                  :to="`/DetalheAssociado/${tr.idAssociado}`"
                >
                  <feather-icon icon="ExternalLinkIcon" svgClasses="h-4 w-4" />
                </router-link>
              </vs-td>

              <!-- Nome Associado -->
              <vs-td>
                {{ tr.nomeAssociado }}
              </vs-td>

              <!-- Valor Pagamento -->
              <vs-td>
                {{ tr.valorPagamento | currency }}
              </vs-td>

              <!-- Data Pagamento-->
              <vs-td>
                {{ tr.dataPagamento | formatDate }}
              </vs-td>

              <!-- Verificado-->
              <vs-td class="table-content-center">
                <vs-checkbox
                  v-model="tr.verificado"
                  @click="sinalizaVerificado(tr)"
                />
              </vs-td>

              <!-- Ações -->
              <vs-td>
                <div class="flex gap-2">
                  <vs-button
                    v-tooltip="'Detalhes'"
                    radius
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-search"
                    class="d-inline"
                    @click="showModal(tr)"
                  ></vs-button>
                </div>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>

      <vs-pagination
        class="mt-4"
        :max="9"
        v-if="countPage"
        :total="countPage"
        v-model="currentPage"
      ></vs-pagination>
    </vx-card>

    <ModalDetails
      :item="itemModal"
      @sinalizaVerificado="sinalizaVerificadoModal($event)"
      @removerCanceladoRemovido="removerCanceladoRemovido($event)"
      @close="closeModal"
    />
  </div>
</template>

<script>
import services from '../../../../services';
import notify from '../../../../utils/notify';

import FiltroPagamentoInconsistentes from './FiltroPagamentoInconsistentes.vue';
import ModalDetails from './ModalDetails.vue';
import SelectPagination from '../../../../utils/list/header/SelectPagination.vue';

export default {
  components: {
    FiltroPagamentoInconsistentes,
    ModalDetails,
    SelectPagination,
  },
  data() {
    return {
      isMounted: false,
      itens: [],

      itemsPerPage: 10,
      currentPage: 1,
      countPage: 0,
      totalCount: 0,

      itemModal: null,
    };
  },
  watch: {
    currentPage() {
      this.loadData();
    },
    itemsPerPage() {
      this.loadData();
    },
  },
  methods: {
    async removerCanceladoRemovido(item) {
      try {
        this.$vs.loading();

        const { idBoleto, idAssociado } = item;

        const data = {
          idBoleto,
          idAssociado,
        };

        const response = await services.post(
          'pagamentos-inconsistentes',
          'remove-cancelado-ou-removido',
          data,
        );

        if (response.data) {
          const result = response.data;
          window.location.reload();
        }

        notify.notifySuccess(this.$vs, 'Boleto reprocessado!');
      } catch (error) {
        notify.notifyFail(this.$vs, error);
        this.$vs.loading.close();
      } finally {
        this.$vs.loading.close();
      }
    },
    async loadData(filter) {
      try {
        this.$vs.loading();
        this.itens = [];

        const response = await services.post(
          'pagamentos-inconsistentes',
          'list ',
          {
            currentPage: this.currentPage,
            itemsPerPage: this.itemsPerPage,
            filter,
          },
        );

        this.itens = response.data.list;
        this.totalCount = response.data.count;

        this.countPage = this.totalCount / this.itemsPerPage;
        if (this.countPage % 1 != 0) {
          this.countPage++;
        }
        this.countPage = parseInt(this.countPage);
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    async sinalizaVerificado(value) {
      const idBoleto = value.idBoleto;
      const verificado = !value.verificado;

      try {
        this.$vs.loading();

        const data = {
          idBoleto,
          verificado,
        };

        const response = await services.post(
          'pagamentos-inconsistentes',
          'sinalizar-verificado',
          data,
        );

        if (response.data) {
          const result = response.data;

          value.dataUltimaVerificaaco = result.dataUltimaVerificaaco;
          value.nomeUsuario = result.nomeUsuario;
        }

        notify.notifySuccess(
          this.$vs,
          'Pagamento Inconsistentes atualizado com sucesso!',
        );
      } catch (error) {
        value.verificado = !verificado;
        notify.notifyFail(this.$vs, error);
        this.$vs.loading.close();
      } finally {
        this.$vs.loading.close();
      }
    },
    async sinalizaVerificadoModal(value) {
      if (this.itemModal.verificado != value) {
        await this.sinalizaVerificado(this.itemModal);
        this.itemModal.verificado = value;
      }

      this.closeModal();
    },
    showModal(value) {
      this.itemModal = value;
    },
    closeModal() {
      this.itemModal = null;
    },
  },
  mounted() {
    this.isMounted = true;
    this.loadData();
  },
};
</script>

<style lang="scss">
@import './../../../../utils/list/style-table.scss';

.table-head {
  width: 16%;
}

.table-content-center {
  .vs-table-text {
    display: block;
    text-align: center;
  }

  span {
    .con-vs-checkbox {
      justify-content: center !important;
    }
  }
}

#data-list-pagamentos-inconsistentes {
  @include style-table;
}
</style>
